import { UserProfile } from '../../../types';
import { USER_KEY } from './constants';
import { validatedEnv } from '../../../utils/env';

const DEFAULT_USER: UserProfile = {
    id: '',
    name: '',
    email: '',
    phone: '',
    isVerified: false,
    memberSince: new Date().getFullYear().toString()
};

export class LocalProfileRepo {
    async getUserProfile(): Promise<UserProfile | null> {
        try {
            const stored = localStorage.getItem(USER_KEY);
            if (stored) return JSON.parse(stored);
        } catch { }
        return DEFAULT_USER;
    }

    async updateUserProfile(profile: Partial<UserProfile>): Promise<UserProfile> {
        if (validatedEnv.PROD) {
            console.error('CRITICAL: Local profile fallbacks are strictly disabled in production.');
            throw new Error('Local fallbacks are strictly disabled in production.');
        }
        const current = await this.getUserProfile();
        const updated = { ...current, ...profile };
        localStorage.setItem(USER_KEY, JSON.stringify(updated));
        return updated;
    }

    async getAllUserProfiles(): Promise<UserProfile[]> {
        return [await this.getUserProfile()];
    }

    async syncAuth(data: { email?: string; name?: string; notify_on_message?: boolean; notify_on_status_change?: boolean }): Promise<void> {
        console.log('📡 [Local] Syncing auth data:', data);
        if (validatedEnv.PROD) {
            console.error('CRITICAL: Local auth sync fallbacks are disabled in production.');
            throw new Error('Local fallbacks are strictly disabled in production.');
        }
        const profile = await this.getUserProfile();
        let changed = false;
        if (profile) {
            if (data.email) { profile.email = data.email; changed = true; }
            if (data.name) { profile.name = data.name; changed = true; }
            if (data.notify_on_status_change !== undefined) { 
                profile.notify_on_status_change = data.notify_on_status_change; 
                changed = true; 
            }
            if (changed) { await this.updateUserProfile(profile); }
        }
    }
}
